import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import styles from './imageSlider.module.scss'
import AwesomeSlider from 'react-awesome-slider'
//@ts-ignore
import withAutoplay from 'react-awesome-slider/dist/autoplay'
import 'react-awesome-slider/dist/styles.css'
import MyPreloader from '../../commons/preloader/preloader'
import withRouter from '../../../hooks/withRouter'
import { RootState } from '../../../redux/store'

const AutoplaySlider = withAutoplay(AwesomeSlider)

interface ImageSliderProps {
  mainSliderImages: string[]
}

const ImageSlider = (props: ImageSliderProps) => {
  const { mainSliderImages } = props

  return (
    <>
      {mainSliderImages.length > 0 ? (
        <AutoplaySlider
          play={true}
          bullets={false}
          animation="cubeAnimation"
          className={styles.slider}
          cancelOnInteraction={false}
          interval={5000}
        >
          {mainSliderImages.map((image) => (
            <div key={image} data-src={image} />
          ))}
        </AutoplaySlider>
      ) : (
        <div className={styles.emptyBlok}>
          <MyPreloader />
        </div>
      )}
    </>
  )
}

let mapStateToProps = (state: RootState) => {
  return {}
}

export default compose(connect(mapStateToProps, {}), withRouter)(ImageSlider)
